export default __webpack_public_path__ + "static/media/Punto_02_Fortezza_Vecchia_e_Darsena_Vecchia_ITA_Def.f43f37a8.aac";